import React, { Fragment, useContext } from 'react';
import { H4, LI, UL, Image } from '../../../../../../AbstractElements';
import CartContext from '../../../../../../_helper/Ecommerce/Cart';
import paypal from '../../../../../../assets/images/checkout/paypal.png';
import upi from '../../../../../../assets/images/checkout/Group 34387.png';
import { Col, Input, Label, Row } from 'reactstrap';
import { useLocation } from 'react-router';

const ProductPlaceOrder = () => {
  const { cart } = useContext(CartContext);

  const location = useLocation()
  const {rowData, data} = location.state || {}

  console.log(rowData)
  return (
    <Fragment>
      <Col xl='6' sm='12'>
        <div className='checkout-details'>
          <div className='order-box'>
            <div className='title-box'>
              <div className='checkbox-title'>
                <H4>Prescription </H4>
                <span>Total</span>
              </div>
            </div>
            {cart &&
              cart.map((item) => {
                return (
                  <UL attrUL={{ className: 'simple-list border-x-0 border-t-0 qty' }} key={item.id}>
                    <LI attrLI={{ className: 'border-0' }}>
                      {item.name} x {item.qty}
                      <span>${item.price}</span>
                    </LI>
                  </UL>
                );
              })}
          
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
              <b> Total </b><span className='count'>&#x20B9;<b> {rowData.sum} </b><br />
                {/* <p className='text-sm text-info' style={{fontSize: "10px"}}>Included Tax</p> */}
                </span>
                
                {/* Total <span className='count'>$ {getCartTotal(cart)}</span> */}
              </LI>
            </UL>
            {rowData.prescription.map((prep, index) => (
              <>
            <UL key={index} attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Due Amount <span className='count'>&#x20B9; {prep.balance === null? '-' : prep.balance}</span>
                {/* Total <span className='count'>$ {getCartTotal(cart)}</span> */}
              </LI>
            </UL>
            <UL attrUL={{ className: 'simple-list sub-total total' }}>
              <LI attrLI={{ className: 'border-0 bg-transparent ' }}>
                Paid Amount <span className='count'>&#x20B9; {prep.already_paid === null? '-' : prep.already_paid }</span>
                {/* Total <span className='count'>$ {getCartTotal(cart)}</span> */}
              </LI>
            </UL>
            </>
))}
            {/* <div className='animate-chk'>
              <Row>
                <Col>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani'>
                    <Input className='radio_animated' id='edo-ani' type='radio' name='rdo-ani' data-original-title='' title='' />
                    Check Payments
                  </Label>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani1'>
                    <Input className='radio_animated' id='edo-ani1' type='radio' name='rdo-ani' data-original-title='' title='' />
                    Cash
                  </Label>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani2'>
                    <Input className='radio_animated' id='edo-ani2' type='radio' name='rdo-ani' data-original-title='' title='' />
                    UPI ID
                    <Image attrImage={{ className: 'img-upi', src: `${upi}`, alt: 'UPI Payment' }} />
                  </Label>
                  <Label className='d-flex align-items-center' htmlFor='edo-ani3'>
                    <Input className='radio_animated' id='edo-ani3' type='radio' name='rdo-ani' data-original-title='' title='' />
                    PayPal
                    <Image attrImage={{ className: 'img-paypal', src: `${paypal}`, alt: 'Paypal' }} />
                  </Label>
                </Col>
              </Row>
            </div> */}
          </div>
        </div>
      </Col>
    </Fragment>
  );
};
export default ProductPlaceOrder;
